import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { updateLeaderboard, deleteLeaderboard, createLeaderboard } from '@/redux/actions';

const WS_EVENTS_BY_HTTP = {
	CREATE: 'event/:eventID/leaderboards/POST',
	DELETE: 'event/:eventID/leaderboards/:leaderboardID/DELETE',
	UPDATE: 'event/:eventID/leaderboards/:leaderboardID/PATCH',
};

const LeaderboardSubscriptions = props => {
	const { socket, updateLeaderboard, createLeaderboard, deleteLeaderboard, currentEventId } = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribe = () => {
		socket.emit('event/:eventID/leaderboards/SUBSCRIBE', { eventID: currentEventId });
	};

	const unsubscribe = () => {
		socket.emit('event/:eventID/leaderboards/UNSUBSCRIBE', { eventID: currentEventId });
	};

	const listenForUpdatedLeaderboard = () => {
		socket.on(WS_EVENTS_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error updating leaderboard', error);
			else {
				updateLeaderboard(data);
				displayMessage('Leaderboard saved');
			}
		});
	};

	const listenForDeletedLeaderboard = () => {
		socket.on(WS_EVENTS_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error deleting leaderboard');
			else {
				deleteLeaderboard(data);
				displayMessage('Leaderboard deleted');
			}
		});
	};

	const listenForCreatedLeaderboard = () =>
		socket.on(WS_EVENTS_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error creating leaderboard', error);
			else {
				createLeaderboard(data);
				displayMessage('Leaderboard created');
			}
		});

	const listeners = () => [
		listenForCreatedLeaderboard,
		listenForDeletedLeaderboard,
		listenForUpdatedLeaderboard,
	];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribe}
				unsub={unsubscribe}
				listeners={listeners()}
				routes={Object.values(WS_EVENTS_BY_HTTP)}
				from="LeaderboardSubscriptions"
			/>
			{React.cloneElement(props.children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	updateLeaderboard: leaderboard => dispatch(updateLeaderboard(leaderboard)),
	deleteLeaderboard: leaderboardID => dispatch(deleteLeaderboard(leaderboardID)),
	createLeaderboard: leaderboard => dispatch(createLeaderboard(leaderboard)),
});

export default connect(msp, mdp)(LeaderboardSubscriptions);
